import { WaypointType } from 'src/graphql/generated/graphql.generated';

export interface WaypointTypeConfig {
  name: string;
  icon: string;
}

export const waypointTypeConfig: {
  [ot in WaypointType]: WaypointTypeConfig;
} = {
  PublicRelationsSite: {
    name: 'Public Relations Site',
    icon: 'voice_chat',
  },
  EnRouteDiversion: {
    name: 'En-Route Diversion',
    icon: 'directions',
  },
  FuelBurn: {
    name: 'Fuel Burn',
    icon: 'local_gas_station',
  },
  FuelLocation: {
    name: 'Fuel Location',
    icon: 'local_gas_station',
  },
  Other: {
    name: 'Other',
    icon: 'place',
  },
  Post: {
    name: 'Post',
    icon: 'place',
  },
  ReceivingFacility: {
    name: 'Receiving Facility',
    icon: 'domain',
  },
  RendezvousPoint: {
    name: 'Rendezvous Point',
    icon: 'place',
  },
  SceneLocation: {
    name: 'Scene Location',
    icon: 'local_hospital',
  },
  SendingFacility: {
    name: 'Sending Facility',
    icon: 'domain',
  },
  PatientPickupRendezvous: {
    name: 'Patient Pickup',
    icon: 'domain',
  },
  PatientDropoffRendezvous: {
    name: 'Patient Dropoff',
    icon: 'domain',
  },
  PickupTeam: {
    name: 'Pickup Team',
    icon: 'place',
  },
  DropoffTeam: {
    name: 'Dropoff Team',
    icon: 'place',
  },
};
